import { type FC } from 'react';
import { createProvider } from '../../../utils/createProvider';
import { useLocation } from '@packages/router-dom';
import { DETAIL_TO_LIST_PAGE_TYPE_ID_MAP, PATH_TO_PAGE_TYPE_ID_MAP } from '../const';

const [Provider, useProvider] = createProvider<{
	pageTypeId: number | null;
	listPageTypeId: number | null;
}>({
	contextName: 'ToolNavigationActiveModuleContext',
	strict: false,
});

export const useToolNavigationActiveModuleProvider = useProvider;

export const ToolNavigationActiveModuleProvider: FC<React.PropsWithChildren> = ({ children }) => {
	const location = useLocation();
	const activePath = Object.keys(PATH_TO_PAGE_TYPE_ID_MAP).find((path) =>
		location.pathname.toLowerCase().startsWith(path),
	);
	const pageTypeId = activePath ? PATH_TO_PAGE_TYPE_ID_MAP[activePath] : null;
	const listPageTypeId = DETAIL_TO_LIST_PAGE_TYPE_ID_MAP[pageTypeId] || pageTypeId;

	return (
		<Provider
			value={{
				pageTypeId,
				listPageTypeId,
			}}
		>
			{children}
		</Provider>
	);
};
